<div class="form-group">
  <div class="floating-input-wrapper" [ngClass]="{ 'has-password-toggle': type === 'password' }">
    <div class="gradient-border">
      <input
        [type]="type === 'password' ? (show ? 'text' : 'password') : type"
        [name]="fieldName"
        [id]="fieldName"
        class="floating-input"
        [value]="value"
        (input)="onChange($event)"
        (blur)="onTouched()"
        [disabled]="disabled"
        [ngClass]="{
          'is-invalid': formField && formField.touched && formField.errors,
          'has-value': value
        }"
        [placeholder]="label"
      />
      <label class="floating-label" [htmlFor]="fieldName">{{ label }}</label>
    </div>
    
    @if (type === 'password') {
      <button
        type="button"
        class="password-toggle"
        (click)="show = !show"
        tabindex="-1"
      >
        @if (!show) {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.92 11.6C19.9 6.91 16.1 4 12 4C7.90001 4 4.10001 6.91 2.08001 11.6C2.02494 11.7262 1.99652 11.8623 1.99652 12C1.99652 12.1377 2.02494 12.2738 2.08001 12.4C4.10001 17.09 7.90001 20 12 20C16.1 20 19.9 17.09 21.92 12.4C21.9751 12.2738 22.0035 12.1377 22.0035 12C22.0035 11.8623 21.9751 11.7262 21.92 11.6ZM12 18C8.83001 18 5.83001 15.71 4.10001 12C5.83001 8.29 8.83001 6 12 6C15.17 6 18.17 8.29 19.9 12C18.17 15.71 15.17 18 12 18ZM12 8C11.2089 8 10.4355 8.2346 9.77773 8.67412C9.11993 9.11365 8.60724 9.73836 8.30449 10.4693C8.00174 11.2002 7.92252 12.0044 8.07686 12.7804C8.2312 13.5563 8.61217 14.269 9.17158 14.8284C9.73099 15.3878 10.4437 15.7688 11.2196 15.9231C11.9956 16.0775 12.7998 15.9983 13.5307 15.6955C14.2616 15.3928 14.8864 14.8801 15.3259 14.2223C15.7654 13.5645 16 12.7911 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8ZM12 14C11.6044 14 11.2178 13.8827 10.8889 13.6629C10.56 13.4432 10.3036 13.1308 10.1522 12.7654C10.0009 12.3999 9.96126 11.9978 10.0384 11.6098C10.1156 11.2219 10.3061 10.8655 10.5858 10.5858C10.8655 10.3061 11.2219 10.1156 11.6098 10.0384C11.9978 9.96126 12.3999 10.0009 12.7654 10.1522C13.1308 10.3036 13.4432 10.56 13.6629 10.8889C13.8827 11.2178 14 11.6044 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14Z"
              fill="currentColor"
            />
          </svg>
        }
        @if (show) {
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.94 5.07994C10.2908 5.02617 10.6451 4.99943 11 4.99994C14.18 4.99994 17.17 7.28994 18.91 10.9999C18.6439 11.5645 18.3433 12.1122 18.01 12.6399C17.9042 12.8038 17.8486 12.9949 17.85 13.1899C17.8522 13.4082 17.9258 13.6197 18.0595 13.7922C18.1931 13.9647 18.3796 14.0888 18.5903 14.1455C18.8011 14.2021 19.0246 14.1883 19.2268 14.106C19.4289 14.0238 19.5986 13.8776 19.71 13.6899C20.1759 12.9579 20.5806 12.1886 20.92 11.3899C20.9737 11.2652 21.0013 11.1308 21.0013 10.9949C21.0013 10.8591 20.9737 10.7247 20.92 10.5999C18.9 5.90994 15.1 2.99994 11 2.99994C10.5307 2.99758 10.0621 3.03774 9.6 3.11994C9.46868 3.14227 9.34304 3.19024 9.23026 3.26112C9.11748 3.332 9.01976 3.4244 8.94269 3.53304C8.86561 3.64169 8.8107 3.76445 8.78107 3.89432C8.75144 4.02419 8.74768 4.15862 8.77 4.28994C8.79233 4.42126 8.8403 4.5469 8.91118 4.65968C8.98206 4.77247 9.07446 4.87018 9.1831 4.94726C9.29175 5.02433 9.41451 5.07925 9.54438 5.10888C9.67425 5.13851 9.80868 5.14227 9.94 5.11994V5.07994ZM2.71 1.28994C2.61676 1.1967 2.50607 1.12274 2.38425 1.07228C2.26243 1.02182 2.13186 0.99585 2 0.99585C1.86814 0.99585 1.73758 1.02182 1.61575 1.07228C1.49393 1.12274 1.38324 1.1967 1.29 1.28994C1.1017 1.47824 0.995911 1.73364 0.995911 1.99994C0.995911 2.26624 1.1017 2.52164 1.29 2.70994L4.39 5.79994C2.97558 7.16147 1.84986 8.79393 1.08 10.5999C1.02494 10.7261 0.996517 10.8623 0.996517 10.9999C0.996517 11.1376 1.02494 11.2738 1.08 11.3999C3.1 16.0899 6.9 18.9999 11 18.9999C12.7971 18.9875 14.5518 18.4524 16.05 17.4599L19.29 20.7099C19.383 20.8037 19.4936 20.8781 19.6154 20.9288C19.7373 20.9796 19.868 21.0057 20 21.0057C20.132 21.0057 20.2627 20.9796 20.3846 20.9288C20.5064 20.8781 20.617 20.8037 20.71 20.7099C20.8037 20.617 20.8781 20.5064 20.9289 20.3845C20.9797 20.2627 21.0058 20.132 21.0058 19.9999C21.0058 19.8679 20.9797 19.7372 20.9289 19.6154C20.8781 19.4935 20.8037 19.3829 20.71 19.2899L2.71 1.28994ZM9.07 10.4799L11.52 12.9299C11.351 12.9784 11.1758 13.002 11 12.9999C10.4696 12.9999 9.96086 12.7892 9.58579 12.4142C9.21072 12.0391 9 11.5304 9 10.9999C8.99795 10.8241 9.02154 10.649 9.07 10.4799ZM11 16.9999C7.82 16.9999 4.83 14.7099 3.1 10.9999C3.74609 9.57369 4.66307 8.28652 5.8 7.20994L7.57 8.99994C7.15425 9.75874 6.99574 10.6319 7.11826 11.4884C7.24078 12.3449 7.63772 13.1386 8.24953 13.7504C8.86134 14.3622 9.65503 14.7592 10.5115 14.8817C11.3681 15.0042 12.2412 14.8457 13 14.4299L14.59 15.9999C13.5011 16.6408 12.2634 16.9856 11 16.9999Z"
              fill="currentColor"
            />
          </svg>
        }
      </button>
    }
  </div>

  @if (formField && formField.touched && formField.errors) {
    <div class="error-message">
      @if (formField.hasError('required')) {
        <small>{{ label }} is required</small>
      }
      @if (formField.hasError('email')) {
        <small>{{ label }} is invalid</small>
      }
      @if (formField.hasError('pattern')) {
        <small>{{ label }} must include an uppercase, a lowercase, a number and a symbol</small>
      }
      @if (minLength && formField.hasError('minlength')) {
        <small>{{ label }} must be at least {{ minLength }} characters</small>
      }
      @if (maxLength && formField.hasError('maxlength')) {
        <small>{{ label }} must not exceed {{ maxLength }} characters</small>
      }
    </div>
  }
</div>
